import { render, staticRenderFns } from "./AiSupplementFields.vue?vue&type=template&id=fd61bad0&scoped=true"
import script from "./AiSupplementFields.vue?vue&type=script&lang=ts"
export * from "./AiSupplementFields.vue?vue&type=script&lang=ts"
import style0 from "./AiSupplementFields.vue?vue&type=style&index=0&id=fd61bad0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd61bad0",
  null
  
)

export default component.exports